import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ICalculationExpressionBehavior } from "../../../../documaker/domain/format/objects";

export interface ICalculationExpressionBehaviorPropertyEditable {
  calculationExpressionBehavior(): IPropertyEditable<ICalculationExpressionBehavior>;
}

export function instanceOfICalculationExpressionBehaviorPropertyEditable(instance: any): instance is ICalculationExpressionBehaviorPropertyEditable {
  return instance
    && instance.calculationExpressionBehavior
    && instanceOfIPropertyEditable<ICalculationExpressionBehavior>(instance.calculationExpressionBehavior());
}
